const sampleMixin = {
    methods: {
        hello() {
            console.log('Hello from sampleMixin')
        }
    }
}

export default sampleMixin
